import { render, staticRenderFns } from "./qarule.vue?vue&type=template&id=5f3c95a8&"
import script from "./qarule.vue?vue&type=script&lang=js&"
export * from "./qarule.vue?vue&type=script&lang=js&"
import style0 from "./qarule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports